import { InjectionToken, isDevMode } from '@angular/core';

let logWebComponentName: string | null = null;

export function setWebComponentName(name: string | null): void {
    logWebComponentName = name;
}

export function devLog(...args: unknown[]): void {
    if (isDevMode()) {
        console.warn(logWebComponentName ? `[${logWebComponentName}]` : '', ...args); // NOSONAR
    }
}

export const URL_ALLOWED_LIST = ['/services/*', '/services-gwc/*', '/api/*', '/cil/*'];
export const AUTH_HEADER_NAME = new InjectionToken<string>('AUTH_HEADER_NAME', {
    providedIn: 'root',
    factory: () => 'Authorization'
});
export const API_BASE_URL = new InjectionToken<string | null>('API_BASE_URL', {
    providedIn: 'root',
    factory: () => null
});

export const TOKEN_SYNC_EVENT = 'mijn-auth-token-sync';
export const TOKEN_REQUEST_EVENT = 'mijn-auth-token-request';
